import React from "react";

import CustomIcon from "../../../app/generic/customIcon";

const CashOnDeliveryIcon = ({ valid }) => (
  <CustomIcon type={valid ? "check" : "close"} />
);

export default CashOnDeliveryIcon;
